export default __webpack_public_path__ + "ea2f46167b6068661d05f102088ccd24.svg";